import React, { useCallback, useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "../utils/NotFound";
// import MerchantOrders from "../components/merchant/orders";
import MerchantProducts from "../components/merchant/products";
import MerchantQRCode from "../components/merchant/qrcode";
// import MerchantReports from "../components/merchant/report";
import MerchantEmployee from "../components/merchant/employee";
import MerchantSubscription from "../components/merchant/subscription";
import { CustomerOrderInfo, SubscriptionInfo, UserInfo } from "../context";
import axios from "axios";
import MerchantDelivery from "../components/merchant/delivery";
import RenewSubscription from "../components/merchant/renew";
import MerchantReport from "../components/merchant/report";
// import * as PusherPushNotifications from "@pusher/push-notifications-web";
import _ from "lodash";
import MerchantTabOrders from "../components/merchant/orders";
import MerchantBanner from "../components/merchant/banner/MerchantBanner";
import MerchantAdditional from "../components/merchant/addtional-services";
// import useSound from "use-sound";
import beep from "./../assets/notification6.mp3";
import MerchantOrderPayLater from "../components/merchant/pay-later";
// import MerchantOrderQueuing from "../components/merchant/queue/MerchantOrderQueuing";
// import { useRef } from "react";

const MerchantRoute = () => {
  // const [play] = useSound(beep, {
  //   interrupt: true,
  // });
  const soundNotif = new Audio(beep);
  // const audioPlayer = useRef(null);
  // function playAudio() {
  //   audioPlayer.current.play();
  // }

  const { channel, userData } = useContext(UserInfo);
  const [subscriptionDetails, setSubscriptionDetails] = useState({
    data: [],
    ready: false,
  });
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const [additionalService, setAdditionalService] = useState({
    data: [],
    ready: false,
  });
  // const [nowServingList, setNowServingList] = useState({
  //   data: [],
  //   ready: false,
  // });
  // const [toProductionList, setToProductionList] = useState({
  //   data: [],
  //   ready: false,
  // });

  const getSubscriptionDetails = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/subscription-details", { params })
      .then((response) => {
        const data = response.data;
        setSubscriptionDetails({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getMerchantOrderSaveList = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      status: 0,
      orderby: "asc",
      order_category: "products",
    };
    axios
      .get("user/merchant/customer-order-list", {
        params,
      })
      .then((response) => {
        const res = _.chain(response.data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: value,
            customer_name: value[0].customer_name,
            created_at: value[0].created_at,
            table_no: value[0].table_no,
            service_category: value[0].service_category,
            cost: getTotalCost(value),
          }))
          .value();
        const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        setMerchantOrderSaveList({ data: res2, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getAdditionalService = useCallback(() => {
    // setLoading(true);
    var params = {
      user_id: userData.data.id,
      status: 0,
      orderby: "asc",
      order_category: "additional-service",
      allow_housekeeping: userData.data.usersmerpermission.find(
        ({ permission }) => permission === "allow-house-keeping"
      )
        ? "yes"
        : "no",
    };
    axios
      .get("user/merchant/customer-order-list", {
        params,
      })
      .then((response) => {
        // console.log("qweqweqweqe");
        // setLoading(false);
        const res = _.chain(response.data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: value,
            customer_name: value[0].customer_name,
            created_at: value[0].created_at,
            table_no: value[0].table_no,
            service_category: value[0].service_category,
            started_date: value[0].started_date,
            ended_date: value[0].ended_date,
            service_type: value[0].service_type,
          }))
          .value();
        const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        setAdditionalService({ data: res2, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getTotalCost = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseInt(data[i].is_per_piece) === 1
          ? parseInt(data[i].quantity) *
            parseFloat(data[i].price.replace(",", ""))
          : parseFloat(data[i].price.replace(",", ""));
    }
    return total;
  };

  // const getNowServing = useCallback(() => {
  //   var params = {
  //     user_id: userData.data.id,
  //     status: 1,
  //     production_complete: 1,
  //     merchant_complete: 0,
  //     orderby: "asc",
  //   };
  //   axios
  //     .get("user/merchant/complete/customer-order-list", {
  //       params,
  //     })
  //     .then((response) => {
  //       const data = response.data;
  //       setNowServingList({ data, ready: true });
  //     })
  //     .catch((error) => {
  //       console.log("ERROR: ", error);
  //     });
  // }, [userData.data.id]);

  // const getToProduction = useCallback(() => {
  //   var params = {
  //     user_id: userData.data.id,
  //     status: 1,
  //     production_complete: 0,
  //     orderby: "asc",
  //     sub_category: "all",
  //   };
  //   axios
  //     .get("user/merchant/production/customer-order-list", {
  //       params,
  //     })
  //     .then((response) => {
  //       const data = response.data;
  //       setToProductionList({ data, ready: true });
  //     })
  //     .catch((error) => {
  //       console.log("ERROR: ", error);
  //     });
  // }, [userData.data.id]);

  useEffect(() => {
    getSubscriptionDetails();
    getMerchantOrderSaveList();
    getAdditionalService();
    // getNowServing();
    // getToProduction();

    channel.bind(
      "customer-order-" + userData.data.merchant_uid,
      function (data) {
        if (data.event_code === "customer-order-list") {
          soundNotif.play();
          getMerchantOrderSaveList();
        }
      }
    );

    channel.bind(
      "customer-production-" + userData.data.merchant_uid,
      function (data) {
        if (data.event_code === "customer-production-list") {
          // soundNotif.play();
          getMerchantOrderSaveList();
          // getToProduction();
        }
      }
    );

    // channel.bind(
    //   "customer-now-serving-" + userData.data.merchant_uid,
    //   function (data) {
    //     if (data.event_code === "customer-now-serving-list") {
    //       soundNotif.play();
    //       getToProduction();
    //       getNowServing();
    //     }
    //   }
    // );

    return () => {
      channel.unbind("customer-order-" + userData.data.id);
      channel.unbind("customer-production-" + userData.data.id);
      // channel.unbind("customer-now-serving-" + userData.data.id);
    };
  }, [
    getSubscriptionDetails,
    getMerchantOrderSaveList,
    getAdditionalService,
    // getNowServing,
    // getToProduction,
  ]);

  return (
    <>
      {/* {console.log("Qweqwe")} */}
      {subscriptionDetails.ready && (
        <SubscriptionInfo.Provider
          value={{
            subscriptionDetails,
            rerunSubscriptionDetails: () => getSubscriptionDetails(),
          }}
        >
          <CustomerOrderInfo.Provider
            value={{
              merchantOrderSaveList,
              rerunCustomerOrders: () => getMerchantOrderSaveList(),
              additionalService,
              rerunAdditionalService: () => getAdditionalService(),
              // nowServingList,
              // rerunNowServing: () => getNowServing(),
              // toProductionList,
              // rerunToProduction: () => getToProduction(),
            }}
          >
            <React.Fragment>
              <Routes>
                <Route hidden path="/" element={<MerchantTabOrders />} />
                <Route hidden path="/products" element={<MerchantProducts />} />

                {Boolean(
                  parseInt(
                    subscriptionDetails.data.subsmerchantfeat
                      .enable_inventory_report
                  )
                ) ? (
                  <Route
                    hidden
                    path="/delivery"
                    element={<MerchantDelivery />}
                  />
                ) : null}

                <Route hidden path="/qr-code" element={<MerchantQRCode />} />

                {Boolean(
                  parseInt(
                    subscriptionDetails.data.subsmerchantfeat
                      .enable_sales_report
                  )
                ) ? (
                  <Route hidden path="/report" element={<MerchantReport />} />
                ) : null}

                <Route hidden path="/employee" element={<MerchantEmployee />} />

                <Route
                  hidden
                  path="/subscription"
                  element={<MerchantSubscription />}
                />

                <Route
                  hidden
                  path="/renew-subscription"
                  element={<RenewSubscription />}
                />

                {userData.data.usersmerpermission.find(
                  ({ permission }) => permission === "allow-banner"
                ) ? (
                  <Route hidden path="/banner" element={<MerchantBanner />} />
                ) : null}

                {userData.data.usersmerpermission.find(
                  ({ permission }) => permission === "allow-additional-services"
                ) ? (
                  <Route
                    hidden
                    path="/additional-services"
                    element={<MerchantAdditional />}
                  />
                ) : null}

                {userData.data.usersmerpermission.find(
                  ({ permission }) => permission === "allow-dine-paylater"
                ) ? (
                  <Route
                    hidden
                    path="/order-pay-later"
                    element={<MerchantOrderPayLater />}
                  />
                ) : null}
                {/* <Route
                  hidden
                  path="/queuing"
                  element={<MerchantOrderQueuing />}
                /> */}

                {/* {userData.data.usersmerpermission.find(
                  ({ permission }) => permission === "allow-dine-setup"
                ) ? (
                  <Route
                    hidden
                    path="/dine-setup"
                    element={<RenewSubscription />}
                  />
                ) : null} */}

                <Route path="*" element={<NotFound />} />
              </Routes>
              {/* <audio ref={audioPlayer} autoPlay muted src={beep} /> */}
            </React.Fragment>
          </CustomerOrderInfo.Provider>
        </SubscriptionInfo.Provider>
      )}
    </>
  );
};

export default MerchantRoute;
